import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { ShredViewContainer } from './ShredView';
/**
 * Shred View Tab - wrapper component for the main ProposalDashboard
 * Displays the ShredViewContainer with all requirement sections
 */ export const ShredViewTab = /*#__PURE__*/ memo(({ projectId })=>{
    return /*#__PURE__*/ _jsx(ShredViewContainer, {
        projectId: projectId
    });
});
ShredViewTab.displayName = 'ShredViewTab';
